export default __webpack_public_path__ + "static/media/wi-thunderstorm.989e9cae.svg";